module.exports = __webpack_public_path__ + "img/waterFalse.53570e9c.png";